import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './HomeHero.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

function HomeHero() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/sliders/public`);
        const data = await res.json();
        
        // Perfectly connecting the Alt Text
        const formattedSlides = data.map(s => ({
          src: `${API_BASE_URL}${s.src}`,
          altText: s.altText || ''
        }));
        
        setSlides(formattedSlides);
      } catch (error) {
        console.error("Failed to load slides", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSlides();
  }, []);

  const length = slides.length;

  // Auto-slide every 6 seconds
  useEffect(() => {
    if (slides.length > 0) {
      const autoPlay = setInterval(() => {
        setCurrent(prev => (prev === length - 1 ? 0 : prev + 1));
      }, 6000);

      return () => clearInterval(autoPlay);
    }
  }, [slides, length]);

  const nextSlide = () => {
    setCurrent(prev => (prev === length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent(prev => (prev === 0 ? length - 1 : prev - 1));
  };

  if (loading || !slides.length) return null;

  return (
    <section className="home-slider-wrapper">
      <div className="home-slider-container">
        
        {/* --- Background Image Slides --- */}
        {slides.map((slide, index) => {
          return (
            <div 
              className={`home-slider-item ${index === current ? 'active' : ''}`} 
              key={index}
            >
              {/* Image mapping strictly connected to altText */}
              <img 
                 src={slide.src} 
                 alt={slide.altText ? slide.altText : `Slider Image ${index + 1}`} 
                 className="home-slider-media" 
              />
            </div>
          );
        })}

        {/* --- Navigation Buttons --- */}
        {length > 1 && (
          <>
            <button className="home-slider-btn home-slider-btn-left" onClick={prevSlide} aria-label="Previous Slide">
              <FaChevronLeft />
            </button>
            <button className="home-slider-btn home-slider-btn-right" onClick={nextSlide} aria-label="Next Slide">
              <FaChevronRight />
            </button>
          </>
        )}
      </div>
    </section>
  );
}

export default HomeHero;